module.exports = __webpack_public_path__ + "1514116a2d0e713428d4ba9936878436.fbx";